import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { AuthProvider } from "./app/auth/AuthProvider";
import { AppRouter } from "./app/router/AppRouter";
import "./styles/index.css";

const queryClient = new QueryClient({ defaultOptions: { queries: { retry: (count, error) => {
  const status = typeof error === "object" && error !== null && "status" in error ? Number(error.status) : 0;
  return status >= 500 && count < 2;
} } } });

createRoot(document.getElementById("root")!).render(<StrictMode><QueryClientProvider client={queryClient}><AuthProvider><AppRouter /></AuthProvider></QueryClientProvider></StrictMode>);
